module.exports = __webpack_public_path__ + "img/succ.9e00ece2.png";